<template>
    <zen-message-modal :isOpen="isOpen" title="Bulk revoke tokens">
        <p class="text-sm text-taupe-500 mb-4">
            Revoke multiple tokens at once based on criteria. At least one
            criterion is required.
        </p>
        <form @submit.prevent="$emit('submit')" class="space-y-4">
            <div>
                <label
                    for="bulk-user-ulid"
                    class="block text-sm font-medium text-taupe-800 mb-1"
                    >Created by
                    <span class="font-normal text-taupe-500"
                        >(optional)</span
                    ></label
                >
                <zen-auto-complete
                    v-model="userUlid"
                    input-id="bulk-user-ulid"
                    :search="searchUsers"
                    option-label="label"
                    option-value="ulid"
                    placeholder="Revoke all tokens created by this user..."
                    show-dropdown-button
                    :min-length="0"
                />
            </div>
            <div>
                <label
                    for="bulk-unused-days"
                    class="block text-sm font-medium text-taupe-800 mb-1"
                    >Unused for days
                    <span class="font-normal text-taupe-500"
                        >(optional)</span
                    ></label
                >
                <input
                    type="number"
                    id="bulk-unused-days"
                    v-model.number="unusedDays"
                    min="1"
                    max="365"
                    placeholder="e.g. 90"
                    class="block w-full rounded-md border-taupe-300 bg-white px-3 py-2 text-taupe-900 shadow-xs focus:border-sky-500 focus:ring-sky-500 sm:text-sm"
                />
            </div>
            <p v-if="error" class="text-sm text-red-600">
                {{ error }}
            </p>
            <div class="flex justify-end gap-3 pt-2">
                <zen-button variant="secondary" @click="$emit('close')">
                    Cancel
                </zen-button>
                <zen-button
                    type="submit"
                    variant="primary-danger"
                    :disabled="!form.user_ulid && !form.unused_days"
                    :processing="processing"
                    processing-label="Revoking…"
                >
                    Revoke matching tokens
                </zen-button>
            </div>
        </form>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'BulkRevokeApiTokensModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
        searchUsers: {
            type: Function,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: null,
        },
    },
    emits: ['close', 'submit', 'update:form'],
    computed: {
        userUlid: {
            get() {
                return this.form.user_ulid
            },
            set(value) {
                this.$emit('update:form', { ...this.form, user_ulid: value })
            },
        },
        unusedDays: {
            get() {
                return this.form.unused_days
            },
            set(value) {
                this.$emit('update:form', {
                    ...this.form,
                    unused_days: value,
                })
            },
        },
    },
}
</script>
